// icon:bx-atom | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Science.png";

function IconBxAtom(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Science"} />
	)
}

export default IconBxAtom;
